import { PictureElement } from '@/pictureElement/Picture';

import type { ImageProps } from './Image.type';

// Image component renders image based on the props
// but it does optimization of the image based on the props
export const Image = (props: ImageProps) => {
  const { src, alt, objectFit, objectPosition, style, className } = props;

  return (
    <PictureElement src={src}>
      <img
        src={src}
        alt={alt}
        className={`${className} block`}
        style={{
          position: 'absolute',
          objectFit: objectFit,
          objectPosition: objectPosition,
          ...style,
        }}
      />
    </PictureElement>
  );
};
